import ContactAvatarImage from './contactAvatar.webp'

export { ContactAvatarImage }
